import {
  CHANGE_STYLE_SUCCESS,
  CLOSE_DETAIL_EVAL_SUCCESS,
  OPEN_DETAIL_EVAL_SUCCESS,
  OPEN_DETAIL_GRILLE_SUCCESS,
  EXPORT_PDF_DETAIL_EVAL_SUCCESS,
  CLOSE_DETAIL_GRILLE_SUCCESS,
  CHANGE_SCORE_SUCESS,
  CHANGE_TAB_SUCESS,
  CHANGE_TAB2_SUCESS,
  CHANGE_TAB3_SUCESS,
  CHANGE_TAB4_SUCESS,
  CHANGE_SELECTEDTAB_SUCESS,
  CHANGE_SELECTEDTAB2_SUCESS,
  CHANGE_STATUS_SUCCESS,
  CHANGE_TAB_FILTER_LIST_SUCESS
} from "../../actions/design/type";

const initialState = {
  isOpen: false,
  pageNumber: 0,
  prevPage: "home",
  isOpenDetailEval: false,
  exportpdf: 0,
  isOpenDetailGrille: false,
  score: 0,
  selectedBMmalus: [],
  selectedBMmalus1: [],
  selectedBMselectedmalus1: {},
  selectedBMselectedbonus1: {},
  status1: false,
  statusList: [],
  selectedBMbonus: [],
  selectedBMbonus1: [],
  // initialValue : 0,
  // sumWithInitial:0
};

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CHANGE_STYLE_SUCCESS:
      return {
        ...state,
        isOpen: payload.isOpen,
        pageNumber: payload.pageNumber,
        prevPage: payload.prevPage,
      };
    case EXPORT_PDF_DETAIL_EVAL_SUCCESS:
      return {
        ...state,
        exportpdf: payload.exportpdf,
      };
    case OPEN_DETAIL_EVAL_SUCCESS:
      return {
        ...state,
        isOpenDetailEval: payload,
      };
    case CLOSE_DETAIL_EVAL_SUCCESS:
      return {
        ...state,
        isOpenDetailEval: payload,
      };
    case OPEN_DETAIL_GRILLE_SUCCESS:
      return {
        ...state,
        isOpenDetailGrille: payload,
      };

    case CLOSE_DETAIL_GRILLE_SUCCESS:
      return {
        ...state,
        isOpenDetailGrille: payload,
      };
    case CHANGE_SCORE_SUCESS:
      return {
        ...state,
        score: payload.score,
      };
    case CHANGE_TAB_SUCESS:
      return {
        ...state,
        selectedBMmalus: payload.tab,
      };
    case CHANGE_SELECTEDTAB_SUCESS:
      return {
        ...state,
        selectedBMselectedmalus1: payload.selectedtab,
      };
    case CHANGE_SELECTEDTAB2_SUCESS:
      return {
        ...state,
        selectedBMselectedbonus1: payload.selectedtab2,
      };
    case CHANGE_TAB2_SUCESS:
      return {
        ...state,
        selectedBMmalus1: payload.tab2,
      };
    case CHANGE_TAB3_SUCESS:
      return {
        ...state,
        selectedBMbonus: payload.tab3,
      };
    case CHANGE_TAB4_SUCESS:
      return {
        ...state,
        selectedBMbonus1: payload.tab4,
      };
    case CHANGE_STATUS_SUCCESS:
      return {
        ...state,
        status1: payload.status,
      };

      case CHANGE_TAB_FILTER_LIST_SUCESS:
        return {
          ...state,
          statusList: payload.tabOptionsList,
        };

    default:
      return state;
  }
};

export default authReducer;
